import { type Account } from '@tonconnect/ui-react';

import { type Task, type Tasks } from '@/entities/task/model/task.types';

import { type PlatformEvent } from '../services/analytics/types';
import { LIB_NAME } from '../services/service-logger/service-logger';
import { type ServiceEvent } from '../services/service-logger/types';
import { type Game, type RawGenre, type Selection } from '../store/games-store/types';
import { Api } from './helpers/api';

export const api = new Api().instance;

export const getGamesByCategory = <T>(
  category: string,
  page: number = 0,
  size: number = 20
): Promise<T> => {
  return api
    .get<T>(`v1/games/group/${category}`, {
      params: { page, size },
    })
    .then((res) => res.data);
};

export const getGameByKey = (gameKey: string) => {
  return api.get<Game>(`v1/games/key/${gameKey}`).then((res) => res.data);
};

export const getTasks = async () => {
  return (await api.get<Tasks>('v3/wheel/tasks')).data;
};

export const getGenres = async () => {
  return api.get<RawGenre[]>('v1/games/genres').then((res) => res.data);
};

export const getSelections = () => {
  return api.get<Selection[]>('v1/games/selections').then((res) => res.data);
};

export const sendServiceEvent = (body: ServiceEvent) => {
  return api.post<void>(`v1/sentry/log?source=${LIB_NAME}`, body);
};

export const sendWheelTaskClick = (payload: { taskId?: number; gameKey?: string }) => {
  return api.post('v2/wheel/tasks/click', payload);
};

export const completeAd = (taskId: number) => {
  return api.post('v2/wheel/tasks/ad/completed', { taskId });
};

export const sendAnalyticsEvent = (event: PlatformEvent) => {
  return api.post('v1/analytics', event);
};

export const claimTaskPrize = ({
  id,
  userTaskId,
  type,
}: Pick<Task, 'id' | 'userTaskId' | 'type'>) => {
  return api.post<void>('v1/wheel/tasks/claim', {
    taskId: id,
    userTaskId,
    type,
  });
};

export const updateUserWalletProfile = (data: Account) => {
  return api.post('v1/user/profile/tc', data);
};
